// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"72":"0b7b90cd","619":"component---src-templates-site-jsx"}[chunkId] || chunkId) + "-" + {"72":"2ab0fd891b5a1a60097c","454":"84e6eb79ea47a9490393","619":"5710e89f4fa790175a1c"}[chunkId] + ".js";
};